export const trProducts = { DE: 'Produkte', EN: 'Products', FR: 'Produits' };
